import React, { Component, ChangeEvent } from "react";
import { Button, FormControlLabel, Radio, RadioGroup, FormControl } from "@mui/material";

import { IFilterParams } from "ag-grid-community";
import { IFilterReactComp } from "ag-grid-react";
import styles from "./RadioFilter.module.scss";

interface RadioFilterParams {
  radioValue: string;
  filterActive: boolean;
}

interface radioType {
  label: string;
  value: string;
}

class RadioFilter extends Component<IFilterParams, RadioFilterParams> implements IFilterReactComp {
  //private title: string;
  private radioData: radioType[];
  private getCustomValue?: () => string;
  constructor(props: IFilterParams) {
    super(props);
    this.state = {
      filterActive: false,
      radioValue: "",
    };

    this.onButtonClick = this.onButtonClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    // this.title = props.colDef.headerName!;
    this.radioData = props.colDef.filterParams.radioData;
    this.getCustomValue = props.colDef.filterParams?.getCustomValue;
  }

  // Return true if the filter is active. If active then 1) the grid will show the filter icon in the column
  // header and 2) the filter will be included in the filtering of the data.
  isFilterActive() {
    return this.state.filterActive;
  }

  doesFilterPass() {
    return true;
  }

  getModel() {
    if (this.state.filterActive) {
      if (this.getCustomValue) {
        return {
          filterType: "RadioFilter",
          type: this.state.radioValue,
          filter: this.getCustomValue(),
        };
      } else {
        return {
          filterType: "RadioFilter",
          type: "equals",
          filter: this.state.radioValue,
        };
      }
    } else {
      return null;
    }
  }

  setModel(model: any) {
    if (!!model) {
      const { type, filter } = model;
      if (this.getCustomValue) {
        this.setState(
          {
            radioValue: type,
            filterActive: true,
          },
          () => {
            this.props.filterChangedCallback();
          }
        );
      } else {
        this.setState(
          {
            radioValue: filter ?? "",
            filterActive: true,
          },
          () => {
            this.props.filterChangedCallback();
          }
        );
      }
    } else {
      this.setState(
        {
          radioValue: "",
          filterActive: false,
        },
        () => {
          this.props.filterChangedCallback();
        }
      );
    }
  }

  onButtonClick(type: "clear" | "apply") {
    switch (type) {
      case "clear":
        return () => {
          this.setState(
            {
              radioValue: "",
              filterActive: false,
            },
            () => {
              this.props.filterChangedCallback();
            }
          );
        };
      case "apply":
        return () => {
          this.setState(
            {
              filterActive: true,
            },
            () => {
              this.props.filterChangedCallback();
            }
          );
        };
    }
  }

  handleChange(_event: ChangeEvent<HTMLInputElement>, value: string) {
    this.setState({ radioValue: value });
  }

  render() {
    const { filterActive, radioValue } = this.state;

    return (
      <div>
        <div className={styles.filterWrapper}>
          <FormControl component="fieldset">
            <RadioGroup
              onChange={this.handleChange}
              value={radioValue}
            >
              {this.radioData.map((item) => (
                <FormControlLabel
                  key={item.value}
                  value={item.value}
                  control={
                    <Radio
                      size="small"
                      color="primary"
                    />
                  }
                  label={item.label}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </div>
        <div className="ag-filter-apply-panel">
          <Button
            variant="text"
            disabled={!filterActive}
            onClick={this.onButtonClick("clear")}
            className="ag-standard-button ag-filter-apply-panel-button"
          >
            Reset filter
          </Button>
          <Button
            disabled={!!!radioValue}
            variant="text"
            onClick={this.onButtonClick("apply")}
            className="ag-standard-button ag-filter-apply-panel-button"
          >
            Apply filter
          </Button>
        </div>
      </div>
    );
  }
}

export default RadioFilter;
